import { formatDate } from "@/lib/format";

/**
 * Project startDate/endDate are date-only strings ("2026-07-14"). Parsing them
 * with `new Date(...)` yields UTC midnight, which the Montreal formatters
 * (`America/Montreal`) render as the previous calendar day — "2026-07-14" →
 * "13 juill. 2026". The helpers below read the year/month/day straight from the
 * string and anchor them at UTC noon, which formats as the intended day in
 * Montreal regardless of the browser's own timezone.
 */

function parseYmd(value: string | null | undefined): [number, number, number] | null {
  if (!value) return null;
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);

  if (!match) return null;

  return [Number(match[1]), Number(match[2]), Number(match[3])];
}

/** UTC noon on the calendar day the string names, or null when unparseable. */
export function endDayKey(dateStr: string | null | undefined): Date | null {
  const ymd = parseYmd(dateStr);

  if (!ymd) return null;

  return new Date(Date.UTC(ymd[0], ymd[1] - 1, ymd[2], 12));
}

/**
 * Whole-day formatter for date-only fields: "14 juill. 2026". Missing or
 * invalid values fall back to the canonical `—` placeholder.
 */
export function formatWholeDay(dateStr: string | null | undefined): string {
  const day = endDayKey(dateStr);

  if (!day) return "—";

  return formatDate(day);
}
